module.exports = __webpack_public_path__ + "static/Valentina-Quintero-Rodriguezjpg-0586e140414b54caf63accde60cdca51.jpg";